// dependencies
import { CreateProcess } from "redux-process";

// utils
// utils
import serializeObject from "../../utils/SerializeObject";

export const GetReviewReportsAwaitingApproval = CreateProcess({
	method: "GET",
	name: "GetReportsAwaitingApproval",
	type: "EASY_ADD:FETCH_AWAITING_APPROVAL",
	request: (props) => {
		const filters = serializeObject(props.params);
		return {
			url: `/api/reviews/review-reports-awaiting-approval/?${filters}`,
		};
	},
	success: (response) => response.data,
});

export const RespondReviewReportsAwaitingApproval = CreateProcess({
	method: "POST",
	name: "RespondReviewReportsAwaitingApproval",
	type: "EASY_ADD:RESPOND_AWAITING_APPROVAL",

	request: (props) => ({
		url: "/api/reviews/easy-add/respond-review-reports",
		payload: props,
	}),

	success: (response) => response.data,
});
